import styled, { css } from 'styled-components/macro';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import check from 'assets/icons/check.svg';
import question_circle from 'assets/icons/question_circle.svg';

export const ScrollWrapper = styled.div`
  padding: 0;
  margin: 0;
  width: 50%; // 75% доступного пространства основному списку, 25% этому
  height: inherit;
  overflow-y: auto;
  overscroll-behavior-y: none;
  border-left: 1px solid #d8deeb;

  ::-webkit-scrollbar {
    width: 12px;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-track {
    background: inherit;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #e4e8ee;
    border: 4px solid #ffffff;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #9da6b4;
  }
`;

export const Ul = styled.ul`
  list-style-type: none;
  margin: 0;
  padding-left: 0;
`;

export const Text = styled.div`
  width: 100%;
  padding: 10px 0;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const Wrapper = styled.div<{ $isDisabled: boolean }>`
  display: flex;
  background-color: #ffffff;
  justify-content: space-between;
  cursor: default;
  padding: 0 12px;
  gap: 8px;
  align-items: center;

  ${({ theme, $isDisabled }) => css`
    ${Text} {
      color: ${theme.colors.gray[$isDisabled ? '400' : '800']};
      cursor: ${$isDisabled ? 'not-allowed' : 'pointer'};
    }
  `}

  :hover {
    background-color: #f2f5f8;
  }
`;

export const CheckIcon = styled.img.attrs({
  src: check,
})`
  height: 16px;
  width: 16px;
  cursor: pointer;
`;

export const SpinnerWrapper = styled.div`
  display: flex;
  height: 100%;
  font-size: 50px;

  & > i {
    color: #d8deeb;
  }
`;

export const SearchWrapper = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  overflow-x: hidden;
`;

export const SearchInput = styled.input`
  border-radius: 8px;
  border: 1px solid #d8deeb;
  outline: none;
  width: 100%;
  margin: 0 0 4px 4px;
  padding: 12px;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  color: #1f2939;

  ::placeholder {
    color: #697180;
    line-height: 20px;
  }

  :hover {
    border-color: #9da6b4;
  }

  :focus {
    border-color: #9da6b4;
  }
`;

export const SearchInfoIcon = styled.img.attrs({
  src: question_circle,
})`
  position: absolute;
  right: 10px;
  top: 12px;
  cursor: pointer;
  z-index: 9999;
`;

export const StyledReactTooltip = styled(ReactTooltip)`
  z-index: 9999;
  position: fixed;
`;
